import {Button} from '@hm/fundamental'
import {mdiDeleteOutline} from '@mdi/js'
import React from 'react'

import {RoleHaulierLookupChip} from '../../components/Role/RoleHaulierLookupChip'
import {GroupedRoleAssignment} from '../../modules/ManageUsers.selectors'

type HauliersProps = {
  groupedRoleAssignment: GroupedRoleAssignment
  isEditing: boolean
  handleDeleteHaulier?(haulierId: string): void
}

export const Hauliers = ({
  groupedRoleAssignment,
  isEditing,
  handleDeleteHaulier
}: HauliersProps) => {
  const {haulierIds} = groupedRoleAssignment.variantDataScopes

  if (!haulierIds || haulierIds.length === 0) {
    return null
  }

  return (
    <div className="flex flex-col gap-2">
      {groupedRoleAssignment.variantDataScopes.haulierIds?.map((haulierId) => (
        <div key={haulierId} className="flex gap-2">
          <div className="flex-1 border-1px border-border_highlight_10 rounded-lg py-2 px-3 flex flex-col items-start">
            <RoleHaulierLookupChip key={haulierId} haulierId={haulierId} />
          </div>
          {isEditing && (
            <Button
              variant="secondary"
              type="button"
              icon={mdiDeleteOutline}
              onClick={() => {
                handleDeleteHaulier?.(haulierId)
              }}
            >
              Remove
            </Button>
          )}
        </div>
      ))}
    </div>
  )
}
